import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { GetCrmProductHierarchyProductResponseDto } from "../../dtos/crm-product-dto";
import { ProductService } from "../../services/product-service";

type UseGetCrmHierarchyMutationParams = {
  options?: UseMutationOptions<
    GetCrmProductHierarchyProductResponseDto,
    unknown,
    { productId: string }
  >;
};

export const useGetCrmHierarchyMutation = ({
  options
}: UseGetCrmHierarchyMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.getCrmHierarchy({ payload });
    },
    ...options
  });
};
